<template>
    <div
        :class="['detail-download-wrapper', pos === 'top' ? '' : 'pos-bottom']"
        :style="{
            padding: pos === 'top' ? '' : '4vw',
            justifyContent: appDetail.join_community_info ? 'space-between' : 'center',
        }"
    >
        <div
            v-if="pos !== 'top' && appDetail.join_community_info && !$root.isFromTiebaFeed && !showDownloadInfo"
            :class="'old-btn-style'"
            :style="{
                backgroundColor: $root.officialHighLightBtnColor ? officalCommunityBtnColor : 'rgba(51,136,255,0.09)',
                width: '91vw',
            }"
            @click.stop="toTieba"
        >
            <div
                class="btn-text"
                :style="{color: appDetail.officialJoined ? defaultBtnColor : '#3388FF'}"
            >
                {{ appDetail.join_community_info.join_community_txt }}
            </div>
        </div>
        <div
            v-if="pos !== 'top' && appDetail.join_community_info && !$root.isFromTiebaFeed && showDownloadInfo"
            :class="showBottomDownloadBtn ? 'community-btn' : 'old-btn-style'"
            :style="{
                width: showBottomDownloadBtn ? showDownloadInfo ? '10.6vw' : '91vw' : '',
            }"
            @click.stop="toTieba"
        >
            <svg
                class="join-community-icon"
                viewBox="0 0 80 80" version="1.1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <g transform="translate(14.000000, 15.000000)">
                    <!-- eslint-disable -->
                        <path
                            d="M8,0 L44,0 C48.418278,-8.11624501e-16 52,3.581722 52,8 L52,38.3490066 C52,42.7672846 48.418278,46.3490066 44,46.3490066 L39.4451024,46.3490066 L39.4451024,46.3490 L39.4451024,54 L25.5959596,46.3490066 L8,46.3490066 C3.581722, 46.3490066 9.82407092e-14,42.7672846 0,38.3490066 L0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z"
                            :stroke="$root.officialHighLightBtnColor ? $root.officialHighLightBtnColor : '#3183F7'" stroke-width="4"
                            fill="none" stroke-linejoin="round"
                        />
                        <rect
                            stroke="none"
                            :fill="$root.officialHighLightBtnColor ? $root.officialHighLightBtnColor : '#3183F7'" fill-rule="evenodd"
                            x="12" y="16"
                            width="28" height="4"
                            rx="2"
                        />
                        <rect
                            stroke="none"
                            :fill="$root.officialHighLightBtnColor ? $root.officialHighLightBtnColor : '#3183F7'" fill-rule="evenodd"
                            x="12" y="26"
                            width="16" height="4"
                            rx="2"
                        />
                    </g>
                </svg>
                <div class="order-text">去社区</div>
        </div>
        <div
            v-if="pos === 'top' || (showBottomDownloadBtn && showDownloadInfo) || $root.isFromTiebaFeed"
            :class="['old-btn-style',
                     appDetail.recommend_download && pos === 'top' ? 'top-download-btn-has-tieba' : '']"
            :style="{
                backgroundColor: btnColor,
                width: showBottomDownloadBtn ? appDetail.join_community_info && !$root.isFromTiebaFeed
                    ? '78vw' : '91vw' : '',
                border: [DOWNLOADING, SUSPENDED, PENDING].indexOf(downloadStatus) < 0 && appDetail.officialJoined ?
                    `1px solid ${defaultBtnColor}` : `1px solid rgba(51,136,255,0)`,
                color: '#fff',
            }"
            @click.stop="downloadApp"
        >
            <div
                v-if="[DOWNLOADING, SUSPENDED, PENDING].includes(downloadStatus)"
                class="progress-bar"
                :style="{
                    width: `${process}%`,
                    backgroundColor: btnColorRgbaInProgress,
                }"
            ></div>
            <div
                class="btn-text"
                :style="{'margin-right': showBottomDownloadBtn && showPanelBtn ? '4.8vh' : ''}"
            >
                {{ btnText }}
            </div>
            <div
                v-if="showPanelBtn && pos !== 'top'"
                class="panel-btn center"
                :style="{
                    color: $root.officialHighLightBtnColor || '#38f',
                    borderColor: $root.officialHighLightBtnColor || '#38f',
                }"
                @click.stop="openPanel"
            >
                <div class="arrow">
                    <div
                        class="icon"
                        :style="{
                            borderColor: $root.officialHighLightBtnColor || '#38f',
                        }"
                    ></div>
                </div>
                <div class="text">全部</div>
            </div>
        </div>
    </div>
</template>

<script>
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import tbNAPI from '@baidu/tb-napi';
import {downloadApk, isIOS, copy, browserDetect} from '@/utils/browser';
import {getUrlParams, getQueryString} from '@/utils/url';
import ck from '@/utils/ck';
import {getDeepValue} from '@/utils/utility';
import {generateToken} from '@/utils/tiebaUtility';
import ligthingIcon from 'public/assets/imgs/lighting_icon.png';
import useDownload from '@/hooks/useDownload';
import useTbDownload from '@/hooks/useTbDownload';
import {BAIDU_DOWNLOAD_STATUS_MAP, TB_DOWNLOAD_STATUS_MAP} from '@/common/js/Constant';
import {colorRgb} from '@/utils/tool';
export default {
    props: {
        appDetail: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: false,
        },
        officialJoined: {
            type: Boolean,
            required: false,
        },
        isSem: {
            type: Boolean,
            default: false,
        },
        packages: {
            type: Array,
            default: null,
        },
        icon: {
            type: String,
            default: '',
        },
        packageName: {
            type: String,
            default: '',
        },
        appId: {
            type: String,
            default: '',
        },
        interBtnText: { // 干预按钮文案
            type: Object,
            default: () => ({}),
        },
        bussinessInfo: { // 商业包下载信息
            type: Object,
            default: () => ({}),
        },
        downloadUrl: {
            type: String,
            default: '',
        },
        pos: {
            type: String,
            default: 'bottom',
        },
        tiebaInfo: {
            type: Object,
            default: () => {},
        },
        showBottomDownloadBtn: {
            type: Boolean,
            default: false,
        },
        isIos: {
            type: Boolean,
            default: false,
        },
        noChanAdvInfo: {
            type: Array,
            default: () => [],
        },
    },
    setup({appDetail, packages, appId}) {
        const downloadUrl = getDeepValue(packages, '0.download_url');
        const packageName = getDeepValue(packages, '0.package_name');
        const {appName, icon, privacy, publisher, platBaseInfo: {Android: {version, capacity}}} = appDetail;
        const {cid, fid = '', fname = '', position = ''} = getUrlParams();
        // eslint-disable-next-line max-len
        const authorityUrl = `${window.location.origin}/static/game/additionInfo.html?appId=${appId}&isNewFlow=1&channelid=${getQueryString('channelid')}`;
        // eslint-disable-next-line max-len
        const effectUrl = `${window.location.origin}/static/game/desc.html?appId=${appId}&plat=android`;
        let downloadStatusMap = BAIDU_DOWNLOAD_STATUS_MAP;
        let downloadHooksInfo = useDownload(downloadUrl, appId, packageName);
        if (tbNAPI.env.isTBAPP) {
            downloadStatusMap = TB_DOWNLOAD_STATUS_MAP;
            downloadHooksInfo = useTbDownload({
                gameUrl: downloadUrl,
                gameId: appId,
                pkgName: packageName,
                apkName: appName,
                apkIcon: icon,
                apkVersion: version,
                developerName: publisher,
                privacyUrl: privacy,
                authorityUrl,
                packageSize: capacity,
                forumName: '', // 取不到吧名就传空
                versionCode: 1, // 下载端能力兜底，versionCode至少大于0，否则无法发起下载
                source: 6,
                effectUrl,
                type: 1,
                extInfo: {
                    type: '',
                    sourceType: 'gameUnion',
                    objId: 1,
                    gameId: appId,
                    creativeId: cid,
                    fid,
                    fname,
                    locate: position,
                },
            });
        }
        const {downloadStatus, process, handleClick} = downloadHooksInfo;
        return {
            downloadStatus,
            process,
            ...downloadStatusMap,
            handleClick,
        };
    },
    data() {
        return {
            ligthingIcon,
            tiebaLink: '',
            inBdBoxapp: false, // 是否在端内
        };
    },
    computed: {
        showPanelBtn() {
            return getDeepValue(this.packages, 'length') > 1;
        },
        thePackage() {
            return (this.packages && this.packages[0]) || {};
        },
        isLianyun() {
            if (this.packages && this.packages?.length) {
                const index = this.packages.findIndex(item => {
                    return (item.package_type && item.package_type === 1);
                });
                return index >= 0;
            }
            return false;
        },
        isOfficial() {
            if (this.thePackage) {
                return this.thePackage.package_type === 2;
            }
            return false;
        },
        isOtherPac() {
            if (this.thePackage) {
                return this.thePackage.package_type === 3;
            }
            return false;
        },
        btnText() {
            const capacity = getDeepValue(this.packages, '0.capacity');
            let defaultBtnText = '立即下载';
            if (this.$root.isPreDownload && this.isSem) {
                defaultBtnText = '抢先下载';
            }
            else if (this.officialJoined && !this.downloadUrl && this.packages) {
                defaultBtnText = '官方渠道';
            }
            else if (!this.officialJoined && !this.downloadUrl && this.packages) {
                defaultBtnText = '推荐渠道';
            }
            else if (this.noChanAdvInfo.length > 0) {
                defaultBtnText = '推荐游戏';
            }
            else if (this.officialJoined) {
                defaultBtnText = '官方下载';
            }
            let finalText = capacity ? `${defaultBtnText}\xa0${capacity}` : defaultBtnText;
            switch (this.downloadStatus) {
                case this.NOT_STARTED: {
                    break;
                }
                case this.DOWNLOADING: {
                    finalText = `${this.process}%`;
                    break;
                }
                case this.PENDING: {
                    finalText = '加载中...';
                    break;
                }
                case this.SUSPENDED: {
                    finalText = '继续';
                    break;
                }
                case this.COMPLETED: {
                    finalText = '安装';
                    break;
                }
                case this.INSTALLED: {
                    finalText = '打开';
                    break;
                }
                default:
                    finalText = defaultBtnText;
                    break;
            };
            return finalText;
        },
        officalCommunityBtnColor() {
            return colorRgb(this.defaultBtnColor, 0.09);
        },
        btnColorRgbaInProgress() {
            return colorRgb(this.defaultBtnColor, 0.7);
        },
        btnColor() {
            if ([this.DOWNLOADING, this.SUSPENDED, this.PENDING].includes(this.downloadStatus)) {
                return colorRgb(this.defaultBtnColor, 0.7);
            }
            return this.defaultBtnColor;
        },
        defaultBtnColor() {
            return this.$root.officialHighLightBtnColor || '#38f';
        },
        extLog() {
            if (isIOS()) {
                return {};
            }
            const sourceMap = this.$root.DATA_SOURCE;
            const {isFcAdv, fc_package_url} = getUrlParams();
            if ((isFcAdv && this.bussinessInfo) || fc_package_url) {
                return {
                    sourceMap: sourceMap.BUSINESS,
                };
            }
            else if (this.isLianyun) {
                return {
                    sourceMap: sourceMap.LIANYUN,
                };
            }
            else if (this.isOfficial) {
                return {
                    sourceMap: sourceMap.OFFICIAL,
                };
            }
            else if (this.isOtherPac) {
                return {
                    sourceMap: sourceMap.OTHER,
                };
            }
            return {};
        },
        showDownloadInfo() {
            if (!this.packages && this.noChanAdvInfo.length > 0 && !this.isIos) {
                return true;
            }
            else if (!this.packages) {
                return false;
            }
            else if (!isIOS() && this.downloadUrl && (this.appDetail.platBaseInfo.Android.publisher
                || this.appDetail.platBaseInfo.Android.dev) && (this.appDetail.platBaseInfo.Android.permission
                && this.appDetail.platBaseInfo.Android.privacy && this.appDetail.platBaseInfo.Android.version)) {
                return true;
            }
            else if (this.isIos && this.packages) {
                return true;
            }
            else if (!this.downloadUrl && this.packages?.length > 0 && this.appDetail.is_show_third) {
                return true;
            }
            else if (!this.officialJoined && !this.downloadUrl && this.packages) {
                if (this.appDetail.is_show_third === false) {
                    return false;
                }
            }
            return false;
        },
        showShopDownload() {
            if (this.appDetail.third_app_store_name) {
                if (this.inBdBoxapp && this.appDetail.is_show_app_store_layer) {
                    return true;
                }
                else if (!this.inBdBoxapp && this.appDetail.is_show_app_store_layer_out) {
                    return true;
                }
            }
            return false;
        },
    },
    created() {
        this.inBdBoxapp = browserDetect('bdbox');
    },
    mounted() {
        const {action, download_url} = this.thePackage || {};
        const {DOWNLOAD} = this.$root.DOWNLOAD_ACTIONS;
        const {isDownload} = getUrlParams();
        if (action === DOWNLOAD && isDownload === '2') {
            if (this.showShopDownload) {
                setTimeout(() => {
                    this.downloadApp();
                }, 1200);
            }
            else {
                download_url && (location.href = download_url);
            }
        }
        this.$root.sendLog('display', 'communityBtn_display');
        this.ckUtil = ck().getInstance('.old-btn-style');
    },
    methods: {
        downloadApp() {
            // 是否展示第三方商店
            if (this.showShopDownload && !this.$root.isFromTiebaFeed) {
                this.$root.showShopDrawer = true;
            }
            else {
                const {isFcAdv, fc_package_url} = getUrlParams();
                const {DOWNLOAD, JUMP, IOS_DOWNLOAD} = this.$root.DOWNLOAD_ACTIONS;
                const {action, download_url, jump_url} = this.thePackage;
                if (fc_package_url) {// 如果存在商业包下载链接（由前卡传入）,直接使用商业包作为下载链接，商业优先级最高
                    downloadApk(fc_package_url, (this.bussinessInfo && this.bussinessInfo.icon) || this.icon);
                }
                else if (isFcAdv && this.bussinessInfo) {
                    const {appRcv, imTimeSign, downloadUrl} = this.bussinessInfo;
                    const ckUrl = this.ckUtil.addCkOnUrl(appRcv, imTimeSign); // 生成ck计费下载链接
                    const img = document.createElement('img');
                    img.src = ckUrl; // 绕过计费串请求链接的跨域问题
                    img.setAttribute('style', 'display:none');
                    document.body.appendChild(img);
                    // 最终下载使用真实的下载地址（非计费链接）
                    downloadApk(downloadUrl, (this.bussinessInfo && this.bussinessInfo.icon) || this.icon);
                }
                if (IOS_DOWNLOAD === action && jump_url) {
                    location.href = jump_url;
                }
                else if (!this.bussinessInfo && (action === JUMP && jump_url) || (this.noChanAdvInfo.length > 0)) {
                    this.openPanel();
                }
                else if (DOWNLOAD === action && download_url) {
                    this.handleClick();
                }
                this.doClickLog(Object.assign({
                    moduleName: '普通下载',
                    posType: 'highSpeedPos',
                    pageType: 'newDetailPageH5',
                    btnStatus: '下载',
                    isOriginPc: getQueryString('isOriginPc') === '1',
                }, this.extLog));
                this.$emit('showDownloadDawer', true);
            }
        },
        toTieba() {
            this.$root.sendLog('click', 'communityBtn_click');
            const token = this.getToken();
            copy(token);
            this.$root.report(token).then(() => {
                TiebaNewWakeUp.init({
                    page: 'frs',
                    param: {
                        obj_source: 'wise',
                        kw: this.appDetail.join_community_info?.forum_name || '',
                        fid: this.appDetail.join_community_info?.forum_id || '',
                        locate: 'outer_game_joinsq',
                    },
                    androidShoubaiGoCenterPage: false,
                    androidDownUrl: this.appDetail.join_community_info.download_url,
                    ios: 'new',
                    waitTime: 3000,
                    iosDownUrl: isIOS ? this.appDetail.join_community_info.download_url_for_smart : '',
                });
            });
        },
        getToken() {
            let token = '';
            const config = {
                page: 'frs',
                param: {
                    kw: this.appDetail.join_community_info?.forum_name || '',
                    fid: this.appDetail.join_community_info?.forum_id || '',
                    extdata: {}, // 新schema打点
                    track: '', // fe打点
                    locate: 'gamecenter',
                },
            };
            token = generateToken(config);
            return token;
        },
        openPanel() {
            this.$emit('openPanel');
            this.$emit('passBtnTxt', this.btnText);
            this.doShowMoreClickLog();
        },
        doClickLog(exton = {}) {
            let content = {
                value: 'downloadNormal',
                ext: {
                    id: '',
                    ext: Object.assign({
                        multi: !!(this.packages && this.packages?.length > 1),
                        action: this.thePackage && this.thePackage.action,
                    }, this.$root.extData, exton),
                    pos: '',
                },
            };
            this.$logger.click(content);
        },
        doShowMoreClickLog() {
            let content = {
                value: 'unfoldPanel',
                ext: {
                    id: '',
                    ext: Object.assign({
                        multi: !!(this.packages && this.packages?.length > 1),
                        action: this.thePackage && this.thePackage.action,
                        sourceMap: 'third',
                    }, this.$root.extData),
                    pos: '',
                },
            };
            this.$logger.click(content);
        },
        doDisplayLog() {
            this.$logger.display({
                value: 'downloadNormal',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign({
                                multi: !!(this.packages && this.packages?.length > 1),
                                action: this.thePackage && this.thePackage.action,
                            }, this.$root.extData, {
                                moduleName: '普通下载',
                                posType: 'highSpeedPos',
                                pageType: 'newDetailPageH5',
                            }),
                            pos: '',
                        },
                    ],
                },
            });
        },
    },
};

</script>

<style lang="scss" scoped>
@import "~@/common/style/mixin/utils";
$design-width: 1242;

* {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
}

.center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.pos-bottom {
    position: fixed;
    bottom: 0;
    background-color: #fff;
    width: px2rem(1242);
    box-shadow: 0 -2px 5px #eee;
}

.detail-download-wrapper {
    height: px2rem(192);
    display: flex;
    align-items: center;
    padding-bottom: constant(safe-area-inset-bottom); //兼容ios<11.2
    padding-bottom: env(safe-area-inset-bottom); //兼容ios>=11.2
    box-sizing: border-box;
    .go-community {
        position: relative;
        width: px2rem(1140);
        height: px2rem(132);
        line-height: px2rem(132);
        border-radius: px2rem(66);
        font-size: px2rem(54);
        color: #fff;
        text-align: center;
        overflow: hidden;
        transition: width 100ms ease;
        .order-icon {
            width: 80px;
            height: 80px;
        }
    }
    .community-btn {
        text-align: center;
        .join-community-icon {
            width: 80px;
            height: 80px;
        }
        .order-text {
            height: 33px;
            opacity: 0.55;
            font-family: PingFangSC-Regular;
            font-size: 33px;
            color: #000000;
            text-align: center;
            line-height: 33px;
            font-weight: 400;
        }
    }
    .un-checked-recommend {
        position: relative;
        width: px2rem(1140);
        height: px2rem(130);
        line-height: px2rem(130);
        border-radius: px2rem(66);
        font-size: px2rem(54);
        color: #3388FF;
        text-align: center;
        overflow: hidden;
        .btn-text {
            position: relative;
        }
        .progress-bar {
            position: absolute;
            height: 100%;
        }
        .panel-btn {
            width: 150px;
            flex: 0 0 px2rem(160);
            background-color: #fff;
            font-size: px2rem(36);
            border: 1px solid;
            border-radius: 0 px2rem(66) px2rem(66) 0;
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: -15px;
            right: -5px;
            .arrow {
                transform: translateY(px2rem(45));
                .icon {
                    width: px2rem(20);
                    height: px2rem(20);
                    transform: rotateZ(45deg);
                    border-top: px2rem(4) solid #38f;
                    border-left: px2rem(4) solid #38f;
                }
            }
            .text {
                transform: translateY(px2rem(17));
            }
        }
    }
    .old-btn-style {
        position: relative;
        width: px2rem(1140);
        height: px2rem(130);
        line-height: px2rem(130);
        border-radius: px2rem(66);
        font-size: px2rem(54);
        color: #fff;
        text-align: center;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn-text {
            position: relative;
        }
        .recommend-selected-tips {
            height: 51px;
            line-height: 33px;
            text-align: center;
            background-image: linear-gradient(270deg, #F3E8FF 0%, #D7FFFD 100%);
            border-radius: 12px;
            font-size: 36px;
            font-weight: 400;
            color: #3388FF;
            padding: 9px 12px;
            margin-left: 6px;
            box-sizing: border-box;
        }
        .progress-bar {
            position: absolute;
            height: 100%;
            top: 0;
            left: 0;
        }
        .panel-btn {
            width: 150px;
            flex: 0 0 px2rem(160);
            background-color: #fff;
            font-size: px2rem(36);
            border: 1px solid;
            border-radius: 0 px2rem(66) px2rem(66) 0;
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: -15px;
            right: -5px;
            .arrow {
                transform: translateY(px2rem(45));
                .icon {
                    width: px2rem(20);
                    height: px2rem(20);
                    transform: rotateZ(45deg);
                    border-top: px2rem(4) solid #38f;
                    border-left: px2rem(4) solid #38f;
                }
            }
            .text {
                transform: translateY(px2rem(17));
            }
        }
    }
    .top-download-btn-has-tieba {
            font-size: 48px !important;
            height: 119px !important;
    }
}
.light {
    transform: translateX(px2rem(-545));
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: px2rem(545);
    opacity: 0.7;
    background: linear-gradient(
        110deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0)
    );
    -webkit-animation: 2.5s seepmove ease-in-out infinite normal;
    animation: 2.5s seepmove ease-in-out infinite normal;
}
@keyframes seepmove {
    0% {
        -webkit-transform: translateX(px2rem(-800));
        transform: translateX(px2rem(-800));
    }
    40% {
        -webkit-transform: translateX(px2rem(-800));
        transform: translateX(px2rem(-800));
    }
    100% {
        -webkit-transform: translateX(150vw);
        transform: translateX(150vw);
    }
}
</style>